var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"partner"},[_c('h4',[_vm._v("Laman Terkait")]),_c('div',{staticClass:"partner__icon"},_vm._l((_vm.partners),function(partner){return _c('a',{key:partner.name,attrs:{"href":partner.url,"target":"_blank"}},[_c('img',{attrs:{"src":require(`@/assets/home/partner/${partner.name}.png`),"alt":partner.name}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }